import React, { FunctionComponent } from 'react';
import Breadcrumb from '@views/components/breadcrumb/Breadcrumb';

export const Placeholder: FunctionComponent<any> = () => <Breadcrumb />;

export default Placeholder;
